module.exports = __webpack_public_path__ + "static/media/popup-button-check.2bc73fb4.svg";